import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import ContentWrapper from '../components/contentwrapper/ContentWrapper'
import { FaLocationDot, FaRankingStar, FaUserTie } from 'react-icons/fa6'
import { AiFillMobile, AiTwotoneMail } from 'react-icons/ai'
import { useNavigate, useParams } from 'react-router-dom'
import { editDataFromList, updateDataAPI } from '../utils/api'
import { toast } from 'react-toastify'

const initialState = {
    company_name: '',
    company_mobile: '',
    company_email: '',
    company_gst: '',
    company_address: '',
}

const EditCompany = () => {
    const { slug } = useParams();
    const navigate = useNavigate();
    const [values, setInputValues] = useState(initialState);

    useEffect(() => {
        getCompanyData(slug)
    }, [slug]);

    const getCompanyData = (slug) => {
        editDataFromList(`super-admin-get-single-company-data/${slug}`).then((res)=>{
            if(res.data.status===1){
                setInputValues(...[res.data.company])
            }
        })
    }
    const updateCompanyData = async (e) => {
        e.preventDefault();
        try {
            updateDataAPI(`super-admin-update-company-data/${slug}`, values).then((res) => {
                if (res.data.status === 1) {
                    navigate('/company');
                    toast.success("Hr Data has been updated successfully!!");
                }
                else {
                    toast.error("Something Wrongs!!");
                }
            })
        }
        catch (error) {
            toast.error("Connection failed!!")
        }
    }
    const handleInputs = e => {
        setInputValues({
            ...values,
            [e.target.name]: e.target.value,
        })
    }
    return (
        <div className="addCompany">
            <Helmet>
                <title>SATKARTAR:ADMIN::EDIT COMPANY</title>
            </Helmet>

            <ContentWrapper>
                <div className="col-xl-6">
                    <div className="card border-top border-0 border-4 border-danger">
                        <div className="card-body">
                            <div className="card-title d-flex align-items-center">
                                <div>
                                    <FaUserTie className="formIcons" />
                                </div>
                                <h5 className="mb-0 text-danger">Edit Company</h5>
                            </div>
                            <hr />
                            <form className="row g-3" method="post" onSubmit={updateCompanyData}>
                                <div className="col-12">
                                    <label htmlFor="company_name" className="form-label">Company Name</label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-transparent">
                                            <FaUserTie />
                                        </span>
                                        <input type="text" className="form-control border-start-0" id="company_name" name="company_name" placeholder="Company Name" value={values.company_name} onChange={handleInputs} required={true} />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <label htmlFor="company_mobile" className="form-label">Mobile No</label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-transparent">
                                            <AiFillMobile />
                                        </span>
                                        <input type="text" className="form-control border-start-0" id="company_mobile" name="company_mobile" placeholder="Mobile No" value={values.company_mobile} onChange={handleInputs} required={true} maxLength={10} minLength={10} />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <label htmlFor="company_email" className="form-label">Email Address</label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-transparent">
                                            <AiTwotoneMail />
                                        </span>
                                        <input type="email" className="form-control border-start-0" id="company_email" name="company_email" placeholder="Email Address" value={values.company_email} onChange={handleInputs} required={true} />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <label htmlFor="company_gst" className="form-label">GST Number</label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-transparent">
                                            <FaRankingStar />
                                        </span>
                                        <input type="text" className="form-control border-start-0" id="company_gst" name="company_gst" placeholder="GST Number" value={values.company_gst} onChange={handleInputs} required={true} />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <label htmlFor="company_address" className="form-label">Company Address</label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-transparent">
                                            <FaLocationDot />
                                        </span>
                                        <textarea className="form-control border-start-0" id="company_address" name="company_address" placeholder="Company Address" value={values.company_address} onChange={handleInputs} required={true}>
                                        </textarea>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <button type="submit" className="btn btn-danger px-5">Update</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </ContentWrapper>
        </div>
    )
}

export default EditCompany